import { rand, randNumber, randMimeType, randWord, randImg, randCatchPhrase } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { Attachment } from '../base';

export class MockAttachment extends Attachment {
   constructor() {
      super({
         type: rand( ['Commercial Invoice', 'Country of Origin', 'Delivery Instructions'] ),
         filename: '',
         extension: rand([ 'jpeg', 'jpg', 'pdf', 'tiff', 'tif', 'png', 'txt' ]),
         size: randNumber({ max: 1000000 }),
         mimetype: randMimeType(),
      });

      this.filename = randWord() + this.extension;

      if ( optional() ) { this.id = randNumber({ max: 10000 }).toString(); }

      if ( optional() ) { this.data = randImg(); }

      if ( optional() ) { this.name = randCatchPhrase(); }
   }
}
